export class History {
  date: string;
  triedCount: number;
  goaledCount: number;
}
